import { HttpClient } from '@angular/common/http';
import { IFeedback } from './models/feedback.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlService } from 'app/core/http/url.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  public constructor(private readonly http: HttpClient,
              private readonly urlService: UrlService) {}

  public getFeedback(gameShowRunId: string): Observable<IFeedback> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'GameShowRun', gameShowRunId, 'Feedback');

    return this.http.get<IFeedback>(url);
  }

  public sendFeedback(gameShowRunId: string, feedbackTypeId: string, score: number, comments: string): Observable<void> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'GameShowRun', gameShowRunId, 'Feedback', feedbackTypeId, score.toString());

    return this.http.post<void>(url, {Value: comments});
  }

  public like(unitId: string): Observable<void> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'Unit', unitId, 'Like');

    return this.http.put<void>(url, {});
  }

  public unlike(unitId: string): Observable<void> {
    const url = this.urlService.buildServerApiUrl('Teacher', 'Unit', unitId, 'Like');

    return this.http.delete<void>(url);
  }
}
